<form [formGroup]="form">
  <mat-card class="column comparison-card">
    <mat-card-header>
      <mat-card-title><img src="icons/id_card.svg" alt="contact info" /> Primary Contact Info</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary Contact First Name</mat-label>
          <input matInput formControlName="primaryContactFirstName">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary Contact Last Name</mat-label>
          <input matInput formControlName="primaryContactLastName">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary Contact Email Address</mat-label>
          <input matInput formControlName="primaryContactEmail">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary Contact Phone Number</mat-label>
          <input matInput formControlName="primaryContactPhoneNumber">
          <mat-error *ngIf="form.get('primaryContactPhoneNumber')?.hasError('required')">
            Phone Number is required.
          </mat-error>
          <mat-error *ngIf="form.get('primaryContactPhoneNumber')?.hasError('pattern')">
            Please use a valid phone number.
          </mat-error>
        </mat-form-field>
      </div>
    </mat-card-content>
    <mat-divider></mat-divider>
    <div class="row">
      <mat-form-field appearance="outline" class="column">
        <mat-label>Printed Name / eSignature</mat-label>
        <input matInput formControlName="printedName">
      </mat-form-field>
    </div>
  </mat-card>

</form>

